import { styled } from 'styled-components'
import { Block } from 'suomifi-ui-components'
import { responsiveWidth } from 'common-ui-components/src/vtj/theme/helpers'
import media from 'common-ui-components/src/vtj/theme/media'

export const PageBanner = styled(Block)`
  display: flex;
  flex-direction: row;
  background-color: ${(props) => `${props.theme.colors.brandBase}`};
  justify-content: center;
  padding: 0;

  & .fi-heading--h1 {
    line-height: 1.2;
    ${media.mobileAndTablet} {
      font-size: 32px;
    }
    ${media.mobileContent} {
      font-size: 28px;
    }
  }
`

export const BannerContent = styled(Block)`
  ${responsiveWidth()};

  padding-top: ${(props) => `${props.theme.spacing.xl}`};
  padding-bottom: ${(props) => `${props.theme.spacing.xl}`};

  ${media.mobileContent} {
    padding-left: ${(props) => `${props.theme.spacing.s}`};
    padding-right: ${(props) => `${props.theme.spacing.s}`};
  }

  display: flex;
  flex-direction: column;
  background-color: ${(props) => `${props.theme.colors.brandBase}`};
  align-items: start;
  justify-content: center;
  color: white;
  gap: ${(props) => `${props.theme.spacing.xl}`};
`
